import { getFetchWrapper } from "@syf-api-library/core";
import { accountActivityUrl } from "../endpoints.js";
const queryFnFactory = (config, keyProps) => {
  const fetchWrapper = getFetchWrapper(config);
  return () => {
    const params = new URLSearchParams({
      "cipher.accountId": keyProps.accountId
    });
    if (keyProps.accountIdType) {
      params.set("accountIdType", keyProps.accountIdType);
    }
    if (keyProps.cursor) {
      params.set("cursor", keyProps.cursor);
    }
    return fetchWrapper(`${accountActivityUrl}?${params}`, { method: "GET" });
  };
};
export {
  queryFnFactory as default
};
//# sourceMappingURL=query.js.map
